export default __webpack_public_path__ + "static/media/5717-decentralized.a8b3209f.gif";